(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ar-review-badge"] && !Shopify.designMode) return;
  try {
    (function () {
    // Judge.me injects its widget late and under a few different shells depending
    // on install, so resolve the target at click time rather than caching it.
    var TARGETS = [
      '#judgeme_product_reviews',
      '.jdgm-review-widget',
      '.jdgm-rev-widg',
      '.jdgm-widget.jdgm-review-widget',
      '[data-widget-name="review-widget"]'
    ];

    function findWidget() {
      for (var i = 0; i < TARGETS.length; i++) {
        var el = document.querySelector(TARGETS[i]);
        if (el && el.offsetParent !== null) return el;
      }
      return null;
    }

    // ---- Strip dead sort options from the Judge.me widget ----------------
    // The imported reviews carry no photos or video, so "Only pictures",
    // "Pictures first" and "Videos first" are dead ends: choosing one returns an
    // empty list and makes the store look emptier than it is. Judge.me exposes no
    // setting for this, and the widget is Vue-driven and re-renders on sort, page
    // and filter changes, so a one-shot removal does not hold. Hence the observer.
    // Delete this block if photo/video reviews ever start coming in.
    var DEAD_SORTS = ['with_pictures', 'pictures_first', 'videos_first'];

    function stripDeadSorts() {
      var selects = document.querySelectorAll('.jm-sort-dropdown, .jdgm-review-widget select');
      for (var i = 0; i < selects.length; i++) {
        var opts = selects[i].options;
        for (var j = opts.length - 1; j >= 0; j--) {
          if (DEAD_SORTS.indexOf(opts[j].value) !== -1) selects[i].remove(j);
        }
      }
    }

    function watchWidget() {
      var widget = document.querySelector('.jdgm-review-widget');
      if (!widget) return false;
      stripDeadSorts();
      new MutationObserver(stripDeadSorts).observe(widget, { childList: true, subtree: true });
      return true;
    }

    if (!watchWidget()) {
      // widget is injected late; poll briefly rather than observing the whole body
      var tries = 0;
      var poll = setInterval(function () {
        if (watchWidget() || ++tries > 40) clearInterval(poll);
      }, 500);
    }

    document.addEventListener('click', function (event) {
      var badge = event.target.closest('[data-ar-rev]');
      if (!badge) return;

      var widget = findWidget();
      if (!widget) return; // no widget on the page: leave the click inert

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var top = widget.getBoundingClientRect().top + window.pageYOffset - 72;

      window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ar-size-chart"] && !Shopify.designMode) return;
  try {
    window.arSizechartUnit = function (btn) {
    const dialog = btn.closest('dialog');
    dialog.querySelectorAll('.ar-sizechart__unit').forEach(b => b.classList.toggle('is-active', b === btn));
    dialog.querySelectorAll('[data-ar-table]').forEach(t => { t.hidden = t.dataset.arTable !== btn.dataset.unit; });
  };

  // Close the size chart when the backdrop (outside the panel) is clicked.
  document.addEventListener('click', function (e) {
    if (e.target instanceof HTMLDialogElement && e.target.classList.contains('ar-sizechart__dialog')) {
      e.target.close();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
